type TelecomCode = '0' | '1' | '2'

export const REQUIRED_TERMS_SKT_CONFIRM_MESSAGE =
  '휴대폰쿠폰지갑 서비스 이용/인증을 위해 약관 동의가 필요합니다.\n필수 약관에 모두 동의하시겠습니까?'

export const REQUIRED_TERMS_CONFIRM_MESSAGE =
  '서비스 이용을 위해 약관 동의가 필요합니다.\n필수 약관에 모두 동의하시겠습니까?'

export type TermsModalCopy = {
  title?: string
  desc: string
}

export const TERMS_MODAL_COPY: Record<TelecomCode, TermsModalCopy> = {
  '0': {
    desc: REQUIRED_TERMS_SKT_CONFIRM_MESSAGE,
  },
  '1': {
    desc: REQUIRED_TERMS_CONFIRM_MESSAGE,
  },
  '2': {
    desc: REQUIRED_TERMS_CONFIRM_MESSAGE,
  },
}

export function getConfirmMessage(telecom?: string) {
  return telecom === '0' ? REQUIRED_TERMS_SKT_CONFIRM_MESSAGE : REQUIRED_TERMS_CONFIRM_MESSAGE
}

export function getTermsModalCopy(telecom?: string): TermsModalCopy {
  const code: TelecomCode =
    telecom === '0' || telecom === '1' || telecom === '2' ? telecom : '0'
  return TERMS_MODAL_COPY[code]
}
